import React from 'react';
import { CardValide } from './Cards';

const PageEmailOk = ({ history, location }) => {
    let email;
    let ok = false;

    if (location && location.search) {
        const params = new URLSearchParams(location.search);
        email = decodeURIComponent(params.get('email'));
        ok = params.has('ok');
    }

    if (!email) {
        history.push('/');
        return null;
    }

    return (
        <CardValide email={email}>
            {ok ? (
                <p>Vous pouvez désormais vous connecter à votre espace en ligne.</p>
            ) : (
                <p>
                    Merci de vous rendre sur votre boite e-mail <b>{email}</b> afin de valider votre adresse. <br />
                    Pour ce faire il vous suffit de cliquer sur le lien fourni dans le mail.
                </p>
            )}
        </CardValide>
    );
};
PageEmailOk.displayName = 'PageEmailOk';

export default PageEmailOk;



// WEBPACK FOOTER //
// ./src/components/Adherent/PageEmailOk.js